import { ref, shallowReactive, shallowRef } from "vue";
import { tableFromIPC, Table } from "apache-arrow";

// shallowReactive: Vue can track Map key additions, but will NOT recursively
// walk into the Arrow Table values (which are large and immutable).
const cache = shallowReactive(new Map<string, Table>());
const loading = ref(false);
const error = ref<Error | null>(null);

async function loadArrow(url: string): Promise<Table> {
  if (cache.has(url)) return cache.get(url)!;

  loading.value = true;
  try {
    const res = await fetch(url);
    const buffer = await res.arrayBuffer();
    const t = tableFromIPC(buffer);
    cache.set(url, t);
    return t;
  } catch (e) {
    error.value = e as Error;
    throw e;
  } finally {
    loading.value = false;
  }
}

export function useArrowTable() {
  // Expose shallowRef factory so callers store tables safely:
  //   const myTable = useArrowTable().tableRef()
  //   myTable.value = await loadArrow(url)  ✅ shallowRef — no deep tracking
  const tableRef = () => shallowRef<Table | null>(null);

  return {
    loading,
    error,
    loadArrow,
    tableRef,
  };
}